/**
 * `router/news.js`
 *  -  お知らせページ用スクリプト
 *
 * 使用方法:
 *  - /router/index.js initRouterで動的読み込み
 *  - import {newsRouter} from "./router/news.js";
 */


import {tableScrollHint} from "../modules/scrollHint.js";

export const newsRouter = () => {
  console.log("📖 Initializing news page...");
  tableScrollHint();  // 大きいテーブルの横スクロール化
}